class GnlKullanicivarsayilanDTO {
    id: number = 0;
    fkGnlKullanici?: number = null;
    ekranAd?: string = "";
    kontrolad?: string = "";
    deger?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
}
export default GnlKullanicivarsayilanDTO;